import React from 'react';
import { IconButton, Typography, Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { Player } from '@lottiefiles/react-lottie-player';
import { m } from 'framer-motion';

import { RocketAnimation } from '@common/assets';
import { UIStudentDailyAchievement } from '../../model';

const LottiePlayer = styled(Player)`
  width: 45px;
  height: 45px;
`;

const Container = styled(Box)`
  position: absolute;
  top: -105px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 100;
  box-shadow: 6px 12px 12px 0px rgba(0, 0, 0, 0.12);
  padding: 4px 10px 8px 14px;
  border-radius: 12px;
  border: 1px solid #cbd1d7;
  background-color: #fff;
  width: fit-content;
  cursor: default;
`;

const Heading = styled(Typography)`
  color: #0f1629;
  font-size: 16px;
  font-weight: bold;
`;

const BodyText = styled(Heading)`
  color: #0f1629;
  font-size: 15px;
  font-weight: 400;
`;

const StyledIconButton = styled(IconButton)`
  margin-right: -8px;
  color: #6c7589;
`;

type Props = {
  achievement: UIStudentDailyAchievement;
  onClose: () => void;
  visible: boolean;
};

export const ProgressPopup = ({ achievement, onClose, visible = false }: Props) => {
  const { lessonsCompleted, day } = achievement;

  const handleClosePressed = (e: any) => {
    e.stopPropagation();
    onClose();
  };

  if (!visible) {
    return null;
  }

  return (
    <m.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{
        type: 'spring',
        stiffness: 260,
        damping: 20,
      }}
    >
      <Container>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Heading>{day}</Heading>
          <StyledIconButton onClick={handleClosePressed}>
            <CloseIcon fontSize="small" />
          </StyledIconButton>
        </Stack>

        <Stack direction="row" spacing={1} mt={0.25}>
          <BodyText>
            {lessonsCompleted}&nbsp;Lessons <br />
            Completed
          </BodyText>
          <LottiePlayer autoplay loop src={RocketAnimation} />
        </Stack>
      </Container>
    </m.div>
  );
};
